import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import BeaconThemeProvider from "@braze/beacon-styling";
import { createTheme, ThemeProvider } from "@material-ui/core/styles"; 

const theme = createTheme({
  palette: {
    primary: {
      main: "#008294",
    },
    background: {
      default: "red"
    }
  },
  
})
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <BeaconThemeProvider>
          <App />
      </BeaconThemeProvider>
    </ThemeProvider>
      
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();